import { isEmpty } from '@ember/utils';

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/max
// Math.max(...arr) and Math.max.apply(null, arr) would also be solutions here,
// but - as noted in MDN - those approaches may fail for large arrays, due to
// there being a limit to the number of arguments a JS function can accept.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/apply#Using_apply_and_built-in_functions
export function getMaxOfArray(arr) {
  if (isEmpty(arr)) {
    return null;
  }

  return arr.reduce((a, b) => Math.max(a, b));
}

export function getMinOfArray(arr) {
  if (isEmpty(arr)) {
    return null;
  }

  return arr.reduce((a, b) => Math.min(a, b));
}

// Sums an array of arrays "by column", i.e. return an array where each item is
// the sum of items at that index from the input arrays.
// e.g
// [ [1, 2],
//   [2, 3],
//   [3, 4] ] -> [ 6, 9 ]
export function sumArrayItemsByIndex(arrays) {
  return arrays.reduce((acc, a) => {
    a.forEach((b, i) => {
      acc[i] = (acc[i] || 0) + b;
    });
    return acc;
  }, []);
}

// Returns the unique items in an array
export function uniq(array) {
  return array.filter((item, index) => {
    return array.lastIndexOf(item) === index;
  });
}
